var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: " advance-charge-info" },
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAllowedEdit,
                  expression: "isAllowedEdit"
                }
              ],
              staticClass: "operations"
            },
            [
              _c(
                "div",
                { staticClass: "triggers" },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("FinanceManage.adChargeInfo_prepaid"))
                        )
                      ]),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            ref: "apTotalGroup",
                            attrs: {
                              no: "apTotalGroup",
                              "amount-to-currency": _vm.localCurrency,
                              "data-provider": _vm.adList.apTotalGroup,
                              "data-field": "amount",
                              "rate-field": "exchangeRate",
                              "is-gross-profit": true,
                              type: "ap"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "cargo-button-group-slider",
                    {
                      staticStyle: { flex: "1", border: "none" },
                      attrs: { no: "top", align: "right" }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.viewSource !== "salesDetail",
                              expression: "viewSource!=='salesDetail'"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isAllowedEdit,
                                  expression: "isAllowedEdit"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_print",
                                disabled:
                                  !(!_vm.isEdit && _vm.advanceSelected) ||
                                  !_vm.advanceSelected,
                                type: "success"
                              },
                              on: { click: _vm.print }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("FinanceManage.adChargeInfo_print")
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isAllowedEdit,
                                  expression: "isAllowedEdit"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_newAdjustment",
                                disabled: !(_vm.job && _vm.job.jobState === 2),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addCostAdjust("add", false)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "FinanceManage.adChargeInfo_newAdjustment"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isAllowedEdit,
                                  expression: "isAllowedEdit"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_editAdjustment",
                                disabled: !(
                                  _vm.job &&
                                  _vm.job.jobState === 2 &&
                                  _vm.advanceSelected &&
                                  !(
                                    _vm.advanceSelected.billingUuid ||
                                    _vm.advanceSelected.invoiceUuid ||
                                    _vm.advanceSelected.billingPaymentUuid ||
                                    _vm.advanceSelected.confirmBillUuid ||
                                    _vm.advanceSelected.verifiedAmount !== 0
                                  )
                                ),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addCostAdjust("edit", false)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.adChargeInfo_editAdjustment"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isAllowedEdit,
                                  expression: "isAllowedEdit"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_deleteAdjustment",
                                disabled: !(
                                  _vm.job &&
                                  _vm.job.jobState === 2 &&
                                  _vm.advanceSelected &&
                                  !(
                                    _vm.advanceSelected.billingUuid ||
                                    _vm.advanceSelected.invoiceUuid ||
                                    _vm.advanceSelected.billingPaymentUuid ||
                                    _vm.advanceSelected.confirmBillUuid ||
                                    _vm.advanceSelected.verifiedAmount !== 0
                                  )
                                ),
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addCostAdjust("del", false)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.adChargeInfo_deleteAdjustment"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "adChargeInfo_addBoth",
                                disabled: !(_vm.isEdit && _vm.btn.btBothAdd),
                                type: "primary"
                              },
                              on: { click: _vm.bothAddChargeHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("FinanceManage.adChargeInfo_addBoth")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "adChargeInfo_add",
                                disabled: !_vm.isEdit,
                                type: "primary"
                              },
                              on: { click: _vm.addAdvanceHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("FinanceManage.adChargeInfo_add")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "adChargeInfo_delete",
                                disabled: !(_vm.isEdit && _vm.btn.btDel2),
                                type: "danger"
                              },
                              on: { click: _vm.delAdvChargeHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("FinanceManage.adChargeInfo_delete")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isChargeSubmitDirect &&
                                    !_vm.adjust &&
                                    _vm.isSubmitChargeRole,
                                  expression:
                                    "isChargeSubmitDirect && !adjust && isSubmitChargeRole"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_submitCharge",
                                disabled:
                                  _vm.isEdit ||
                                  !_vm.advanceSelected ||
                                  (_vm.advanceSelected &&
                                    Number(_vm.advanceSelected.chargeState) !==
                                      0),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.chargeSubmitEventHandler(1, true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.adChargeInfo_submitCharge"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isChargeSubmitDirect &&
                                    !_vm.adjust &&
                                    _vm.isCancelSubmitChargeRole,
                                  expression:
                                    "isChargeSubmitDirect && !adjust && isCancelSubmitChargeRole"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_cancelSubmit",
                                disabled:
                                  _vm.isEdit ||
                                  !_vm.advanceSelected ||
                                  (_vm.advanceSelected &&
                                    Number(_vm.advanceSelected.chargeState) !==
                                      1),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.chargeSubmitEventHandler(0, true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.adChargeInfo_cancelSubmit"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c("cargo-ag-grid", {
            staticStyle: { "flex-grow": "1", "margin-top": "5px" },
            attrs: {
              no: "130114",
              "config-module": "130114",
              "grid-options": _vm.up.gridOptions,
              "grid-params": _vm.up.gridParams,
              "column-defs": _vm.dynamicColumnDefsForUp,
              "row-data": _vm.up.rowData
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(_vm.up, "gridParams", $event)
              },
              "update:grid-params": function($event) {
                return _vm.$set(_vm.up, "gridParams", $event)
              },
              gridReady: function(params) {
                return (_vm.up.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAllowedEdit,
                  expression: "isAllowedEdit"
                }
              ],
              staticClass: "operations"
            },
            [
              _c(
                "div",
                { staticClass: "triggers", staticStyle: { height: "28px" } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("FinanceManage.adChargeInfo_collect"))
                        )
                      ]),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            ref: "arTotalGroup",
                            attrs: {
                              no: "arTotalGroup",
                              "amount-to-currency": _vm.localCurrency,
                              "data-provider": _vm.adList.arTotalGroup,
                              "data-field": "amount",
                              "rate-field": "exchangeRate",
                              "is-gross-profit": true,
                              type: "ar"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "cargo-button-group-slider",
                    {
                      staticStyle: { flex: "1", border: "none" },
                      attrs: { no: "bottom", align: "right" }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.viewSource !== "salesDetail",
                              expression: "viewSource!=='salesDetail'"
                            }
                          ],
                          staticStyle: { float: "right" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isAllowedEdit,
                                  expression: "isAllowedEdit"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_newAdjustment",
                                disabled: !(_vm.job && _vm.job.jobState === 2),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addCostAdjust("add", true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "FinanceManage.adChargeInfo_newAdjustment"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isAllowedEdit,
                                  expression: "isAllowedEdit"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_editAdjustment",
                                disabled: !(
                                  _vm.job &&
                                  _vm.job.jobState === 2 &&
                                  _vm.agentSelected &&
                                  !(
                                    _vm.agentSelected.billingUuid ||
                                    _vm.agentSelected.invoiceUuid ||
                                    _vm.agentSelected.billingPaymentUuid ||
                                    _vm.agentSelected.confirmBillUuid ||
                                    _vm.agentSelected.verifiedAmount !== 0
                                  )
                                ),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addCostAdjust("edit", true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.adChargeInfo_editAdjustment"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isAllowedEdit,
                                  expression: "isAllowedEdit"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_deleteAdjustment",
                                disabled: !(
                                  _vm.job &&
                                  _vm.job.jobState === 2 &&
                                  _vm.agentSelected &&
                                  !(
                                    _vm.agentSelected.billingUuid ||
                                    _vm.agentSelected.invoiceUuid ||
                                    _vm.agentSelected.billingPaymentUuid ||
                                    _vm.agentSelected.confirmBillUuid ||
                                    _vm.agentSelected.verifiedAmount !== 0
                                  )
                                ),
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addCostAdjust("del", true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.adChargeInfo_deleteAdjustment"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "adChargeInfo_add",
                                disabled: !_vm.isEdit,
                                type: "primary"
                              },
                              on: { click: _vm.addAgentHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("FinanceManage.adChargeInfo_add")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "adChargeInfo_delete",
                                disabled: !(_vm.isEdit && _vm.btn.btDel1),
                                type: "danger"
                              },
                              on: { click: _vm.delAgentChargeHandler }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("FinanceManage.adChargeInfo_delete")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isChargeSubmitDirect &&
                                    !_vm.adjust &&
                                    _vm.isSubmitChargeRole,
                                  expression:
                                    "isChargeSubmitDirect && !adjust && isSubmitChargeRole"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_submitCharge",
                                disabled:
                                  _vm.isEdit ||
                                  !_vm.agentSelected ||
                                  (_vm.agentSelected &&
                                    Number(_vm.agentSelected.chargeState) !==
                                      0),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.chargeSubmitEventHandler(1)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.adChargeInfo_submitCharge"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.isChargeSubmitDirect &&
                                    !_vm.adjust &&
                                    _vm.isCancelSubmitChargeRole,
                                  expression:
                                    "isChargeSubmitDirect && !adjust && isCancelSubmitChargeRole"
                                }
                              ],
                              attrs: {
                                no: "adChargeInfo_cancelSubmit",
                                disabled:
                                  _vm.isEdit ||
                                  !_vm.agentSelected ||
                                  (_vm.agentSelected &&
                                    Number(_vm.agentSelected.chargeState) !==
                                      1),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.chargeSubmitEventHandler(0)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "FinanceManage.adChargeInfo_cancelSubmit"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%", width: "100%", "margin-top": "5px" },
            attrs: {
              no: "130113",
              "config-module": "130113",
              "grid-options": _vm.down.gridOptions,
              "grid-params": _vm.down.gridParams,
              "column-defs": _vm.dynamicColumnDefsForDown,
              "row-data": _vm.down.rowData
            },
            on: {
              "update:gridParams": function($event) {
                return _vm.$set(_vm.down, "gridParams", $event)
              },
              "update:grid-params": function($event) {
                return _vm.$set(_vm.down, "gridParams", $event)
              },
              gridReady: function(params) {
                return (_vm.down.gridApi = params.api)
              }
            }
          }),
          _c(
            "div",
            {
              staticClass: " operations",
              staticStyle: { "margin-top": "10px" }
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Difference")))]),
              _vm.reCalc
                ? _c("charge-currency-total-group", {
                    attrs: {
                      no: "Difference",
                      "amount-to-currency": _vm.localCurrency,
                      "data-field": "amount",
                      "data-provider": _vm.adList.revenueTotalGroup,
                      "rate-field": "exchangeRate",
                      "is-gross-profit": true,
                      type: "revenue"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("adjust-window", {
        ref: "adjustWindow",
        attrs: {
          visible: _vm.adjustWindow.visible,
          "default-properties": _vm.adjustWindow.defaultProperties,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.adjustWindow, "visible", $event)
          },
          returnCall: _vm.callbackHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }